export default __webpack_public_path__ + "static/media/gcash_aliplus.25fcfd7b.svg";